import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Login } from '../../../../core/models/login/login';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useNavigate } from 'react-router-dom';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Lock from '@mui/icons-material/Lock';
import Warning from '@mui/icons-material/Warning';

import logoAPP from "../../../../core/assets/img/logo_cotymse.jpg";
import { COLORS } from '../../../../core/constants/colors';
import { RippleButton } from '../../../components/ui/ripple-button/RippleButton';
import clsx from 'clsx';

const LoginForm = ({ access, loadingButton }) => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Correo inválido").required("Requerido"),
      password: Yup.string().max(12, "Debe de tener 12 caracteres o menos").required("Requerido"),
    }),
    onSubmit: values => access(values),
  });

  return (
    <div className='overflow-hidden' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <form noValidate onSubmit={formik.handleSubmit} className='w-[280px] sm:w-[310px] overflow-hidden' >

        <div className='flex flex-col gap-2 '>
          <TextField
            className='input-autofill'


            variant="standard"

            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            {...formik.getFieldProps('email')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />

          <TextField
            className='input-autofill'

            variant="standard"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            autoComplete="current-password"
            {...formik.getFieldProps('password')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              ),
            }}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
        </div>


        <div className='flex justify-center mt-4'>
          <RippleButton className={clsx(`py-2 px-4 rounded-lg `, {
            'bg-gray-400': !loadingButton,
            'bg-gray-600': loadingButton
          })}
            style={{
              backgroundColor: !loadingButton ? COLORS.principalColor : COLORS.disabledColor,
              // Asumiendo que tienes un secondaryColor

            }} onClick={() => formik.handleSubmit()} >Entrar</RippleButton>
        </div>



        {/* <div
          style={{
            textAlign: 'center',
            color: COLORS.principalColor,
            fontSize: 13,
            marginTop: 45,
            cursor: 'pointer',
            textDecoration: 'none'
          }}
          onClick={() => navigate('/register')}
        >
          <div className='hover:underline'>
            <span>
              ¿No tienes cuenta? Regístrate aquí
            </span>

          </div>

        </div> */}
      </form>
    </div>
  );
};

export default LoginForm;
